import * as ExpressionValType from '../constants/ExpressionValType'
import * as Operator from '../constants/Operator'
import * as ExpressionRelationship from '../constants/ExpressionRelationship'

export class JSCriteriaBuilder {
    constructor(dummy) {
        this.expression = {};
        this.expressions = [];
        if (!dummy)
            this.expressions.push(this.expression);
    }

    setOwnerType(ownerType) {
        this.ownerType = ownerType;
    }

    setSkipSpecialProcessing(skipSpecialProcessing) {
        this.skipSpecialProcessing = skipSpecialProcessing;
    }

    setDistinctValues(distinctValues) {
        this.distinctValues = distinctValues;
    }

    addDefaultCriteria(criteria) {
        let that = this;
        if (!that.expressions)
            return criteria;
        if (!criteria)
            criteria = new JSCriteriaBuilder();
        if (!criteria.expressions)
            criteria.expressions = [];
        let fieldOperatorSet = [];
        for (let e of that.expressions) {
            fieldOperatorSet.push(e.field + e.operator);
        }
        for (let e of criteria.expressions) {
            if (!fieldOperatorSet.contains(e.field + e.operator))
                that.expressions.push(e);
        }
        return that;
    }

    join(criteria) {
        let that = this;
        if (!that.expressions)
            that.expressions = [];
        if (criteria && criteria.expressions) {
            let size = that.expressions.length;
            if (size > 0) {
                that.expressions.insert(0, {operator: Operator.OpenBracket, relation: ExpressionRelationship.AND});
                that.expressions.push({operator: Operator.CloseBracket, relation: ExpressionRelationship.AND});
                that.expressions.push({operator: Operator.OpenBracket, relation: ExpressionRelationship.AND});
            }
            that.expressions.push(...criteria.expressions);
            if (size > 0) {
                that.expressions.push({operator: Operator.CloseBracket, relation: ExpressionRelationship.AND});
            }
        }
        return that;
    }

    /**
     *
     * @param id
     * @return {JSCriteriaBuilder}
     */
    field(id) {
        if (this.expression.field)
            throw new Error("field can be only called once on an expression");
        this.expression.field = id;
        return this;
    }

    /**
     *
     * @param id
     * @return {JSCriteriaBuilder}
     */
    avg(id) {
        this.expression.rightHandSide = id;
        this.expression.setValueType(ExpressionValType.Avg.name());
        return this;
    }

    /**
     *
     * @param id
     * @return {JSCriteriaBuilder}
     */
    min(id) {
        this.expression.rightHandSide = id;
        this.expression.setValueType(ExpressionValType.Min.name());
        return this;
    }

    /**
     *
     * @param id
     * @return {JSCriteriaBuilder}
     */
    max(id) {
        this.expression.rightHandSide = id;
        this.expression.setValueType(ExpressionValType.Max.name());
        return this;
    }

    /**
     *
     * @param id
     * @return {JSCriteriaBuilder}
     */
    theField(id) {
        this.expression.rightHandSide = id;
        this.expression.setValueType(ExpressionValType.AnotherField.name());
        return this;
    }

    /**
     *
     * @param value
     * @return {JSCriteriaBuilder}
     */
    contains(value) {
        this.expression.operator = Operator.Contains;
        this.expression.rightHandSide = value;
        return this;
    }

    /**
     *
     * @param value
     * @return {JSCriteriaBuilder}
     */
    notContains(value) {
        this.expression.operator = Operator.NotContain;
        this.expression.rightHandSide = value;
        return this;
    }

    /**
     *
     * @return {JSCriteriaBuilder}
     */
    openBraket() {
        this.expression.operator = Operator.OpenBracket;
        this.expressions.push(this.expression = {});
        return this;
    }

    /**
     *
     * @return {JSCriteriaBuilder}
     */
    closeBraket() {
        if (this.expression.operator)
            this.expressions.push(this.expression = {});
        this.expression.operator = Operator.CloseBracket
        return this;
    }

    /**
     *
     * @return {JSCriteriaBuilder}
     */
    isNull() {
        return this.equal(null);
    }

    /**
     *
     * @param value
     * @return {JSCriteriaBuilder}
     */
    equal(value) {
        this.expression.operator = Operator.Equal;
        this.expression.rightHandSide = value === null || value === undefined ? null : value.toString();
        return this;
    }

    /**
     *
     * @param fieldId
     * @param op
     * @return {JSCriteriaBuilder}
     */
    compareTo(fieldId, op) {
        this.expression.operator = op;
        this.expression.rightHandSide = fieldId;
        this.expression.valueType = ExpressionValType.AnotherField;
        return this;
    }

    /**
     *
     * @param value
     * @return {JSCriteriaBuilder}
     */
    lessThan(value) {
        this.expression.operator = Operator.LessThan;
        this.expression.rightHandSide = value;
        return this;
    }

    /**
     *
     * @param value
     * @return {JSCriteriaBuilder}
     */
    lessThanOrEqual(value) {
        this.expression.operator = Operator.LessThanOrEqual;
        this.expression.rightHandSide = value;
        return this;
    }

    /**
     *
     * @param value
     * @return {JSCriteriaBuilder}
     */
    greaterThan(value) {
        this.expression.operator = Operator.GreaterThan;
        this.expression.rightHandSide = value;
        return this;
    }

    /**
     *
     * @param value
     * @return {JSCriteriaBuilder}
     */
    greaterThanOrEqual(value) {
        this.expression.operator = Operator.GreaterThanOrEqual;
        this.expression.rightHandSide = value;
        return this;
    }

    /**
     *
     * @param value
     * @return {JSCriteriaBuilder}
     */
    notEqual(value) {
        this.expression.operator = Operator.NotEqual;
        this.expression.rightHandSide = value;
        return this;
    }

    /**
     *
     * @return {JSCriteriaBuilder}
     */
    or() {
        this.relationship(ExpressionRelationship.OR);
        this.expressions.push(this.expression = {});
        return this;
    }

    /**
     *
     * @return {JSCriteriaBuilder}
     */
    and() {
        this.relationship(ExpressionRelationship.AND);
        this.expressions.push(this.expression = {});
        return this;
    }

    /**
     *
     * @param values
     * @return {JSCriteriaBuilder}
     */
    in(values) {
        this.expression.operator = Operator.In;
        this.expression.expressioninValues = values;
        return this;
    }

    /**
     *
     * @param relationship
     * @return {JSCriteriaBuilder}
     */
    relationship(relationship) {
        this.expression.relation = relationship;
        return this;
    }

    /**
     *
     * @return {JSCriteriaBuilder}
     */
    build() {
        return this;
    }

    /**
     *
     * @param operator
     * @return {JSCriteriaBuilder}
     */
    operator(operator) {
        this.expression.operator = operator;
        return this;
    }

    /**
     *
     * @param rightHandSide
     * @return {JSCriteriaBuilder}
     */
    rhs(rightHandSide) {
        this.expression.rightHandSide = rightHandSide;
        return this;
    }

    /**
     *
     * @param strExpression
     * @return {*}
     */
    static criteriaFromStr(strExpression) {
        if (!strExpression)
            return null;
        let criteria = new JSCriteriaBuilder(true);
        if (strExpression.expressions) {
            criteria.expressions.push(...strExpression.expressions);
            return criteria;
        }
        let expressions = strExpression.split(";|\n|\r");
        for (let expression of expressions) {
            let parts = expression.split(",");
            if (parts.length < 2)
                continue;
            let field = parts.length > 0 ? parts[0] : "";
            let operator = parts.length > 1 ? parts[1] : Operator.Equal;
            let rightHandSide = parts.length > 2 ? parts[2] : "";
            let relation = parts.length > 3 ? parts[3] : ExpressionRelationship.AND;
            criteria.expressions.push({field, operator, rightHandSide, relation});
        }
        return criteria;
    }
}